(function () {
    'use strict';

    angular
        .module('chilliAuth')
        .controller('LoginCtrl', LoginCtrl);

    LoginCtrl.$inject = ['$location', 'lock', 'chilliAuthConstants', 'ChilliAuthService'];

    function LoginCtrl($location, lock, chilliAuthConstants, ChilliAuthService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'Login';
        vm.logIn = logIn;
        vm.logOut = ChilliAuthService.logOut;

        activate();

        function activate() {
            if (ChilliAuthService.isAuthenticated) {
                $location.url('/dashboard');
            } else {
                logIn();
            }
        }

        function logIn() {
            ChilliAuthService.showLogin();


            // Unfortunately, the newer version of lock (v11) doesn't allow us to override the 'container' option
            // subsequent to 'init'.
            // If we were going direct to Auth0Lock rather than using the provided Angular wrappers, we could create
            // a new Auth0Lock instance and work that way. But... given that this is just a workaround for IE11-like
            // browsers, and they're not so important (especially in this soon to be deprecated Angular 1.x version
            // of ChilliDocs), so... we just put up with having the default popup instead.

            /*auth.signin({
                authParams: {
                    scope: chilliAuthConstants.AUTH_SCOPE
                },
                icon: 'Images/ChilliDocs-Login-Logo.png',
                closable: false,
                gravatar: false,
                container: 'logincontainer'
            });*/
        }
    }
})();
